import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';
import { TableCell, TableRow } from '@mui/material';

const Fields = () =>(
    <div style={{ display: 'flex', gap: '10px' }}>
    <Skeleton variant="rectangular" animation="wave" width={500} height={50} />
    <Skeleton variant="rectangular" animation="wave" width={500} height={50} />
    <Skeleton variant="rectangular" animation="wave" width={500} height={50} />
    <Skeleton variant="rectangular" animation="wave" width={500} height={50} />
</div>
)

export default function TableShimmer() {

  return (
    <Grid md={12}>
        <Stack spacing={4} sx={{ mt: 2}} >
          <Skeleton variant="h1" sx={{ fontSize: '3rem' }} animation="wave" />
          {[...Array(6)].map((_, index) => (
          <Fields key={index} />
            ))}
        </Stack>

    </Grid>
  );
}